module.exports = __webpack_public_path__ + "media/images/other-images/sad-6a5ce2922f0a88e587584a35afb3bd1b.png";